'use client';

import { useHeroMap } from './model/use-hero-map';
import styles from './hero-map.module.scss';


const BG_SRC = '/img/mapbg.png';
const MAP_SRC = '/img/mapx2.webp';


export function HeroMap () {
    const { heroRef, canvasRef } = useHeroMap();

    return (
        <section ref={ heroRef } className={ styles.hero }>
            <div className={ styles.mask } style={ { backgroundImage: `url(${BG_SRC})` } }/>
            { /* eslint-disable-next-line @next/next/no-img-element */ }
            <img className={ styles.map } src={ MAP_SRC } alt=""/>
            <canvas ref={ canvasRef } className={ styles.fx }/>
        </section>
    );
}
